
// const config = {
//   api: {
//     // baseURL: 'http://localhost:5000/',
//     //baseURL: 'http://92.205.227.135:5000/',
//     baseURL: 'https://api.ssjluxurytransport.com/',
//     emailEndpoint: 'api/email',
//     carsEndpoint: 'api/cars',
//     adminLogin: 'api/admin/login',
//     loginUrl: 'api/login',

//   },
//   whatsapp: {
//     recipientPhone: '919876238140', // Example recipient phone number (India)
//     baseUrl: 'https://wa.me/',
//   },
//   googlemap:{
//     apiKey: 'AIzaSyAXzg4x-WLJFqc02OoS5cKG2GnTqoq65Uc',
//   }
//   // Add any other configuration details you need here
// };

// export default config;




const config = {
  api: {
    //baseURL: 'http://localhost:5000/',
    //baseURL: 'http://92.205.227.135:5000/',
    baseURL: 'https://api.ssjluxurytransport.com/',
    emailEndpoint: 'api/email',
    carsEndpoint: 'api/cars',
    adminLogin: 'api/admin/login',
    loginUrl: 'api/login',
    contactUs: 'api/contact-us'
  },
  whatsapp: {
    recipientPhone: '447956208228', 
    baseUrl: 'https://wa.me/',
  },
  telegram: {
    baseUrl: 'https://t.me/sohail_janjua'
  },
  email: {
    email: 'contact@ssjluxurytransport.com',
  },
  googlemap: {
    apiKey: 'AIzaSyC2hRfEfpkxBSeXrakYgNCHbUdeHN90r84',
  }
};

export default config;

